import React from 'react';
import { MailIcon } from 'lucide-react';
import { Button } from './Button';
type TeamMemberCardProps = {
  name: string;
  firstName: string;
  initials: string;
  title: string;
  email: string;
};
export function TeamMemberCard({
  name,
  firstName,
  initials,
  title,
  email
}: TeamMemberCardProps) {
  return <div className="flex h-full flex-col border-t border-gold/50 pt-6" data-id="element-306" data-mp="124xb5q1vyxg7">
      <div className="flex items-center gap-4" data-id="element-307" data-mp="1738jfwcj8zwb">
        <div role="img" aria-label={`${name} monogram`} className="relative flex h-16 w-16 shrink-0 items-center justify-center bg-navy shadow-[0_10px_24px_-14px_rgba(11,24,48,0.6)]" data-id="element-308" data-mp="172gmoi778w4g">
          <span className="pointer-events-none absolute inset-1.5 border border-gold/50" aria-hidden="true" data-id="element-309" data-mp="1gzblz3bar0js" />
          <span className="font-serif text-2xl font-medium text-gold" data-id="element-310" data-mp="3isj0iaj35e4m">{initials}</span>
        </div>
        <div className="min-w-0" data-id="element-311" data-mp="3mu4ksgxy8uou">
          <h4 className="font-serif text-2xl font-medium leading-tight text-navy" data-id="element-312" data-mp="3mtcr5bnwx717">{name}</h4>
          <p className="mt-1 text-sm text-ink/70" data-id="element-313" data-mp="3s8ebsv2nz133">{title}</p>
        </div>
      </div>

      <a href={`mailto:${email}`} className="mt-5 inline-flex items-start gap-2 self-start break-all rounded-sm text-sm font-medium text-navy underline decoration-gold decoration-1 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-314" data-mp="3ngwau70n50i4">
        <MailIcon size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" aria-hidden="true" data-id="element-315" data-mp="ezjpcxq3t0el" />
        {email}
      </a>

      <div className="mt-auto pt-5" data-id="element-316" data-mp="53gd2z1jfldx">
        <Button href={`mailto:${email}`} size="sm" variant="outline" ariaLabel={`Contact ${firstName} by email at ${email}`} data-id="element-317" data-mp="52f02p0yootk">
          Contact {firstName}
        </Button>
      </div>
    </div>;
}